import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';

import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import FilterListIcon from '@material-ui/icons/FilterList';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import classnames from 'classnames';

import Button, { ButtonProps } from './Button';
import SvgIconWrapper from './SvgIconWrapper';
import Typography from './Typography';

const styles = ({ spacing: { unit } }: Theme) =>
  createStyles({
    root: {
      minWidth: 152,
      paddingLeft: unit * 2,
      paddingRight: unit * 2,
    },
    label: {
      width: '100%',
      textAlign: 'left',
    },
    marginRight: {
      marginRight: unit,
    },
  });

const messages = defineMessages({
  label: {
    id: 'components.v2.ButtonToggleFilters.label',
    defaultMessage: 'Filters',
  },
});

export interface ButtonToggleFiltersProps extends Omit<ButtonProps, 'classes'>, WithStyles<typeof styles> {
  toggled?: boolean;
}

const ButtonToggleFilters: React.FC<ButtonToggleFiltersProps> = ({ classes, className, toggled, ...rest }) => {
  const { formatMessage } = useIntl();

  const Icon = useMemo(() => {
    if (toggled) {
      return CloseIcon;
    }
    return KeyboardArrowDownIcon;
  }, [toggled]);

  return (
    <Button
      className={classnames(classes.root, className)}
      variant={toggled ? 'contained' : 'outlined'}
      color="lightBlue"
      disableFocusRipple
      disableRipple
      size="large"
      {...rest}
    >
      <SvgIconWrapper className={classes.marginRight} Icon={FilterListIcon} color="colorSecondary" fontSize="small" />
      <Typography className={classes.label} color="colorSecondary">
        {formatMessage(messages.label)}
      </Typography>
      <SvgIconWrapper Icon={Icon} color="colorSecondary" fontSize="small" />
    </Button>
  );
};

export default withStyles(styles)(ButtonToggleFilters);
